import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { BasicDropdown } from '../../../components';
import { CityDropdown } from '../../cities/components/city-dropdown';
import { CitiesProvider } from '../../cities/hook';
import { useInternationalization } from '../../i18n';
import { ProvinceDropdown } from '../../provinces/components/province-dropdown';
import { ProvincesProvider } from '../../provinces/hook';
import { setSelectedProvince, setSelectedCity } from '../slice';

const FormLocation = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { translate } = useInternationalization()
  const { selectedProvince, selectedCity } = useSelector(state => state.search)

  const updateProvince = (e) => {
    if(e && e.target && e.target.value){
      const { value } = e.target.value
      console.log({updateProvince: value})
      const newParams = new URLSearchParams(window.location.search);

      dispatch(setSelectedProvince(value))
      dispatch(setSelectedCity({}))
      newParams.delete('provinsi');
      newParams.delete('kota');
      newParams.delete('city');
      newParams.append('provinsi', value);

      const newQueryString = '?' + newParams.toString()

      history.push(location.pathname + newQueryString);
    }
  }

  const updateCity = (e) => {
    console.log(e)
    if(e && e.target && e.target.value){
      const { value } = e.target
      console.log({updateCity: value})
      if(value){
        const newParams = new URLSearchParams(window.location.search);

        dispatch(setSelectedCity(value))
        newParams.delete('city');
        newParams.append('city', value);

        const newQueryString = '?' + newParams.toString()

        history.push(location.pathname + newQueryString);
      }
    }
  }

  return <>
    <div className="mb-8">
      <p className="font-bold text-sm mb-4">
        {translate('SEARCH', 'location')}
      </p>

      <ProvincesProvider>
        <ProvinceDropdown
          defaultValue={selectedProvince}
          updateForm={updateProvince}
          customLabel={<></>}
        />
      </ProvincesProvider>

      {
        selectedProvince ? (
          <CitiesProvider provinceId={selectedProvince}>
            <CityDropdown
              defaultValue={selectedCity}
              updateForm={updateCity}
              customLabel={<></>}
            />
          </CitiesProvider>
        ) : (
          <>
            <BasicDropdown
              placeholder={translate('GENERAL', 'city')}
              options={[]}
              disabled={true}
            />
          </>
        )
      }
    </div>
  </>
}

export default FormLocation
